// NOTE This file is auto-generated by Contentlayer

export { isType } from 'contentlayer2/client'

// NOTE During development Contentlayer imports from `.mjs` files to improve HMR speeds.
// During (production) builds Contentlayer it imports from `.json` files to improve build performance.
import allFaqs from './Faq/_index.json' assert { type: 'json' }
import allLegalStuffs from './LegalStuff/_index.json' assert { type: 'json' }
import allNJClaimsNotices from './NJClaimsNotice/_index.json' assert { type: 'json' }
import allReferralPrograms from './ReferralProgram/_index.json' assert { type: 'json' }
import allTelematics from './Telematics/_index.json' assert { type: 'json' }
import allTermsOfServices from './TermsOfService/_index.json' assert { type: 'json' }
import allPrivacyPolicies from './PrivacyPolicy/_index.json' assert { type: 'json' }
import allPartnesProgramTerms from './PartnesProgramTerms/_index.json' assert { type: 'json' }
import allLemonadeGoesGlobals from './LemonadeGoesGlobal/_index.json' assert { type: 'json' }
import allReferralProgramPromos from './ReferralProgramPromo/_index.json' assert { type: 'json' }
import allPolicyTwos from './PolicyTwo/_index.json' assert { type: 'json' }
import allAccessibilities from './Accessibility/_index.json' assert { type: 'json' }

export { allFaqs, allLegalStuffs, allNJClaimsNotices, allReferralPrograms, allTelematics, allTermsOfServices, allPrivacyPolicies, allPartnesProgramTerms, allLemonadeGoesGlobals, allReferralProgramPromos, allPolicyTwos, allAccessibilities }

export const allDocuments = [...allFaqs, ...allLegalStuffs, ...allNJClaimsNotices, ...allReferralPrograms, ...allTelematics, ...allTermsOfServices, ...allPrivacyPolicies, ...allPartnesProgramTerms, ...allLemonadeGoesGlobals, ...allReferralProgramPromos, ...allPolicyTwos, ...allAccessibilities]


